/* =================== SEJA UM ORGANIZADOR / HEMOTERAPIA — Form Submit =================== */
document.addEventListener("DOMContentLoaded", function () {
  // Form Seja um Organizador
  var formOrg = document.getElementById("form-organizador");
  if (formOrg) {
    var btnSubmitOrg = document.getElementById("btn-submit");

    formOrg.addEventListener("submit", function (e) {
      e.preventDefault();

      if (!formOrg.checkValidity()) {
        formOrg.reportValidity();
        return;
      }

      btnSubmitOrg.disabled = true;
      var originalText = btnSubmitOrg.innerHTML;
      btnSubmitOrg.innerHTML = '<i class="fas fa-spinner fa-spin" style="margin-right: 8px;"></i> Enviando...';

      var formData = new FormData(formOrg);

      fetch(url_base + "acoes/app/seja-um-organizador/envia_organizador.php", {
        method: "POST",
        body: formData
      })
        .then(function (res) {
          if (!res.ok) throw new Error("Erro na rede");
          return res.json();
        })
        .then(function (data) {
          btnSubmitOrg.disabled = false;
          btnSubmitOrg.innerHTML = originalText;

          if (data.status === "success") {
            if (typeof showAlert === "function") {
              showAlert("Sucesso!", data.message, "success");
            } else {
              alert(data.message);
            }
            formOrg.reset();
          } else {
            if (typeof showAlert === "function") {
              showAlert("Ops!", data.message, "error");
            } else {
              alert("Erro: " + data.message);
            }
          }
        })
        .catch(function (err) {
          console.error(err);
          btnSubmitOrg.disabled = false;
          btnSubmitOrg.innerHTML = originalText;
          if (typeof showAlert === "function") {
            showAlert("Erro", "Ocorreu um erro ao enviar a solicitação. Tente novamente mais tarde.", "error");
          } else {
            alert("Ocorreu um erro ao enviar a solicitação. Tente novamente mais tarde.");
          }
        });
    });
  }

  // Form Serviço de Hemoterapia
  var formHemo = document.getElementById("form-hemoterapia");
  if (formHemo) {
    var btnSubmitHemo = document.getElementById("btn-submit-hemoterapia");

    formHemo.addEventListener("submit", function (e) {
      e.preventDefault();

      if (!formHemo.checkValidity()) {
        formHemo.reportValidity();
        return;
      }

      btnSubmitHemo.disabled = true;
      var originalText = btnSubmitHemo.innerHTML;
      btnSubmitHemo.innerHTML = '<i class="fas fa-spinner fa-spin" style="margin-right: 8px;"></i> Enviando...';

      var formData = new FormData(formHemo);

      fetch(url_base + "acoes/app/servico-de-hemoterapia/envia_hemoterapia.php", {
        method: "POST",
        body: formData
      })
        .then(function (res) {
          if (!res.ok) throw new Error("Erro na rede");
          return res.json();
        })
        .then(function (data) {
          btnSubmitHemo.disabled = false;
          btnSubmitHemo.innerHTML = originalText;

          if (data.status === "success") {
            if (typeof showAlert === "function") {
              showAlert("Sucesso!", data.message, "success");
            } else {
              alert(data.message);
            }
            formHemo.reset();

            // Reset the dynamic city select field
            var selectCidade = document.getElementById("hemoterapia-cidade");
            if (selectCidade) {
              selectCidade.innerHTML = '<option value="">Selecione o Estado primeiro</option>';
              selectCidade.disabled = true;
            }
          } else {
            if (typeof showAlert === "function") {
              showAlert("Ops!", data.message, "error");
            } else {
              alert("Erro: " + data.message);
            }
          }
        })
        .catch(function (err) {
          console.error(err);
          btnSubmitHemo.disabled = false;
          btnSubmitHemo.innerHTML = originalText;
          if (typeof showAlert === "function") {
            showAlert("Erro", "Ocorreu um erro ao enviar o cadastro. Tente novamente mais tarde.", "error");
          } else {
            alert("Ocorreu um erro ao enviar o cadastro. Tente novamente mais tarde.");
          }
        });
    });

    // Dynamic state/city selector for Hemoterapia
    var estadoHemo = document.getElementById("hemoterapia-estado");
    var cidadeHemoContainer = document.getElementById("hemoterapia-cidade-container");
    if (estadoHemo && cidadeHemoContainer) {
      estadoHemo.addEventListener("change", function () {
        var uf = this.value;
        if (!uf) {
          cidadeHemoContainer.innerHTML =
            '<label for="hemoterapia-cidade">Cidade</label>' +
            '<div class="input-relative">' +
              '<i class="fas fa-map-marker-alt input-icon"></i>' +
              '<select name="cidade" id="hemoterapia-cidade" class="campo campo-com-icone" required disabled>' +
                '<option value="">Selecione o Estado primeiro</option>' +
              '</select>' +
              '<span class="arrow"></span>' +
            '</div>';
          return;
        }

        cidadeHemoContainer.innerHTML =
          '<label for="hemoterapia-cidade">Cidade</label>' +
          '<div class="input-relative">' +
            '<i class="fas fa-map-marker-alt input-icon"></i>' +
            '<select name="cidade" id="hemoterapia-cidade" class="campo campo-com-icone" required disabled>' +
              '<option value="">Carregando cidades...</option>' +
            '</select>' +
            '<span class="arrow"></span>' +
          '</div>';

        fetch("https://servicodados.ibge.gov.br/api/v1/localidades/estados/" + uf + "/municipios?ordenar=nome")
          .then(function (res) {
            if (!res.ok) throw new Error("Erro na rede");
            return res.json();
          })
          .then(function (data) {
            var options = '<option value="">Selecione a Cidade</option>';
            data.forEach(function (city) {
              options += '<option value="' + city.nome + '">' + city.nome + '</option>';
            });

            cidadeHemoContainer.innerHTML =
              '<label for="hemoterapia-cidade">Cidade</label>' +
              '<div class="input-relative">' +
                '<i class="fas fa-map-marker-alt input-icon"></i>' +
                '<select name="cidade" id="hemoterapia-cidade" class="campo campo-com-icone" required>' +
                  options +
                '</select>' +
                '<span class="arrow"></span>' +
              '</div>';
          })
          .catch(function (err) {
            console.warn("API IBGE indisponível. Mudando para campo de texto.", err);
            cidadeHemoContainer.innerHTML =
              '<label for="hemoterapia-cidade">Cidade</label>' +
              '<div class="input-relative">' +
                '<i class="fas fa-map-marker-alt input-icon"></i>' +
                '<input type="text" name="cidade" id="hemoterapia-cidade" class="campo campo-com-icone" placeholder="Digite sua cidade" required />' +
              '</div>';
          });
      });
    }
  }
});
